export default __webpack_public_path__ + "static/media/insta13.5bb11027.webp";